import { Container, Row, Col } from 'react-bootstrap'
import { DigitalLibrary} from '@components/Block'


function JoinFree() {
    return (
        <>
            <div className="joinFree bg01 mt-md-5">
                <Container>
                    <h3 className="text-green text-center my-5"><strong>Join Free and Get Instant Access To:</strong></h3>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <h4><strong>Live Events</strong></h4>
                            <p>Watch health and wellness experts and scientists share the straight facts on important wellness topics that can change the quality of your family's health and the health of our planet.</p>
                            <p>You can watch any of our streams or wellness webinars live or access all of our archived replays on demand from any mobile device.</p>
                        </Col>
                        <Col md={6}>
                            <img src="../images/home/live-events.png" alt="desktop" className="img-fluid"/>
                        </Col>
                    </Row>
                </Container>

                {/* Live Events Videos */}
                <div className="joinFree__liveEvents mx-auto mb-md-7 text-center">
                    <Container>
                        <p className="mt-5 pt-4 mb-4 text-center mb-5">Here is a sample of the high-quality content available inside:</p>
                    </Container>
                    <img src="../images/home/img-live-events01.png" alt="high-quality content" className="img-fluid"/>
                </div>

                {/* Weekly Articles */}
                <div className="joinFree__weeklyArticles mt-md-0 mt-5 mb-6 text-white">
                    <Container className="py-5">
                        <p>&nbsp;</p>
                        <p className="d-md-block d-none">&nbsp;</p>
                        <p className="d-md-block d-none">&nbsp;</p>
                        <h3 className="text-center"><strong>Weekly Articles</strong></h3>
                        <p className="text-center mb-5">You'll be able to read and share well-researched, info-packed articles on topics ranging from: <br className="d-lg-block d-none"/> natural nutrition and beauty, kids health, healthy weight and fitness, healthy home, and more!</p>
                        <p className="d-md-block d-none">&nbsp;</p>
                        <p className="d-md-block d-none">&nbsp;</p>
                    </Container>
                </div>
            </div>
            <div className="joinFree bg02 mb-5">
                <Container>
                    {/* Digital Library */}
                    <div className="joinFree__digitalLibrary mb-6">
                        <h4 className="text-center mt-5"><strong>Digital Library</strong></h4>
                        <p className="text-center mb-5">Get access to our info-packed file cabinet loaded with e-books and resources including:</p>
                        <Row> 
                            <DigitalLibrary/>
                        </Row>
                        <p>&nbsp;</p>
                    </div>

                    {/* Monthly Newsletter */}
                    <div className="joinFree__videoLibrary mb-7">
                        <Row className="align-items-center justify-content-center">
                            <Col md={6}>
                                <h4><strong>Monthly E-Newsletter</strong></h4>
                                <p>The science behind natural nutrition, supplementation, and natural wellness is always evolving. We'll ensure you're kept in the loop with the latest information and discoveries that matter to you, your families, or your wellness clients.</p>
                                <p>You can also opt-out anytime and still access the wellness center.</p>
                            </Col>
                            <Col md={6} className="text-center">
                                <img src="../images/home/vfl-newsletters02.png" className="img-fluid"/>
                            </Col>
                        </Row>
                    </div>
                
                    {/* Video Library */}
                    <div className="joinFree__videoLibrary mb-4">
                        <Row className="align-items-center">
                            <Col md={{span:6, order:2}}>
                                <h4><strong>Video Library</strong></h4>
                                <p className="mb-5">We add new videos regularly that cover a wide range of topics, from information on our preferred wellness brands to helpful tips and wellness tutorials.</p>
                            </Col>
                            <Col md={{span:6, order:1}}>
                                <img src="../images/home/img-video-library01.png" className="img-fluid" alt="Video Library"/>
                            </Col>
                        </Row>
                    </div>
        
                </Container>
            </div>
            <style jsx>{`
                .joinFree__weeklyArticles{
                    background: url(../images/home/bg-weekly-articles01.jpg) top center no-repeat;
                }
                @media (min-width:1199px){
                    .joinFree.bg01{
                        background-image: url(../images/home/img-live-event-bg01.png);
                        background-repeat: no-repeat;
                    }
                    .joinFree.bg02{
                        background-image: url(../images/home/img-bg-02-desktop01.png);
                        background-repeat: no-repeat;
                    }
                }
                @media (max-width:1645px){
                    .joinFree{
                        background-position-x: 30%;
                    }
                }
                @media (min-width:1200px){
                }
            `}</style>
        </>
    )
}

export default JoinFree



